import react from 'react';

export class MapButton extends react.Component {
  constructor(props) {
    super(props);
    this.state = { 
      onClick: props.onClick,
      isActive: props.isActive,
      className: props.className,
      children: props.children,
      disabled: props.disabled === true
    };
  }

  componentWillReceiveProps(props) {
    this.setState(
      { 
        message: props.message,
        isActive: props.isActive,
        disabled: props.disabled === true
      });  
  }

  render() {
    let active = this.state.isActive? "active"  : "";
    let disabled = this.state.disabled;
    return <button type="button" className = {`btn btn-map ${this.state.className} ${active}`} onClick = {this.state.onClick} disabled = {disabled}>
        {this.state.children}
      </button>
  }
}